'use strict';

var toggleTasks = require('./toggleTasks');
var scrollToElement = require('../../helpers/scrollToElement');

function showMoreBehaviour ($marketingChecklist, $showMore, showLess) {
  var $tasksList = $marketingChecklist.find('.marketing-checklist-list');

  $showMore.toggleClass('open', !showLess);
  $tasksList.toggleClass('open', !showLess);

  if (showLess === true) {
    scrollToElement($marketingChecklist);
  }

  return toggleTasks($marketingChecklist);
}

module.exports = showMoreBehaviour;
